import styled from 'styled-components';

export const AccountTitle = styled.p` ${({ theme }) => `
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.bold};
  padding-top:${theme.padding[2]};
  padding-bottom:${theme.padding[2]};
`}`;
